import { useState } from 'react'

const FAQS = [
  {
    q: 'Do I need any real estate experience to use this?',
    a: 'No prior experience is required. REILM guides you through each analysis step, so both beginners and seasoned investors can make informed decisions.',
  },
  {
    q: 'What does the platform actually replace?',
    a: 'REILM consolidates spreadsheets, comps tools, and CRM workflows into a single pipeline so you can underwrite, score, and track every deal in one place.',
  },
  {
    q: 'How accurate are the projections?',
    a: 'Projections use live market data and your inputs to model ARV, rehab, and BRRRR returns. They are estimates intended to support — not replace — your own diligence.',
  },
  {
    q: 'Can I analyze any type of property?',
    a: 'Yes. REILM supports single-family flips, BRRRR rentals, and small multifamily. Pick the strategy and the analysis adjusts to fit.',
  },
]

const Icon = ({ open }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M4 10h12" />
    {!open && <path d="M10 4v12" />}
  </svg>
)

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (i) => setOpenIndex((current) => (current === i ? -1 : i))

  return (
    <section className="bg-brand-pageFill">
      <div className="max-w-canvas mx-auto px-[120px] pt-[96px] pb-[120px] flex justify-between gap-12">
        <h2 className="w-[352px] text-[36px] leading-[48px] font-extrabold text-brand-dark shrink-0">
          Common Questions,
          <br />
          <span className="text-brand-green">Clear Answers</span>
        </h2>

        <div className="w-[732px] flex flex-col">
          {FAQS.map(({ q, a }, i) => {
            const isOpen = openIndex === i
            return (
              <div key={q} className="border-b border-[#a7c199] py-6 flex flex-col gap-4">
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  className={`flex items-center justify-between text-left ${
                    isOpen ? 'text-brand-green' : 'text-brand-dark'
                  }`}
                >
                  <span className="text-[20px] leading-[32px] font-bold">{q}</span>
                  <Icon open={isOpen} />
                </button>
                {isOpen && (
                  <p className="text-[16px] leading-[28px] text-brand-dark">{a}</p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Faq
